"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _SkipLink = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-skip-link';
/** Keyboard, screen readers, switch controls
 * and other assistive technologies users use skip links to reach main content or other important
 * sections easier and faster.
 *
 *  CoreUI provides a skip link on the page to skip navigation,
 * but consumers may want to use skip links to skip sections.
 *
 * In most cases, the single skip link provided on the page by CoreUI is sufficient.
 * A very complex page with several repeated elements may necessitate additional skip links.
 * Remember, the purpose of skip navigation links
 *  is to make keyboard navigation more efficient. Adding more links increases link-clutter. Source: [WebAIM](https://webaim.org/techniques/skipnav/)
 *
 *
 *  > Currently unsupported: **Listbox** with grouping, **GridListbox** with grouping.
 * [UICOMP-9786](https://jira.concur.com/browse/UICOMP-9786) */
var SkipLink = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _a = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(SkipLink, props)) : props,
    className = _a.className,
    url = _a.url,
    label = _a.label,
    inList = _a.inList,
    linkProps = __rest(_a, ["className", "url", "label", "inList"]);
  var classnames = _bind.default.bind(_SkipLink.default);
  return /*#__PURE__*/_react.default.createElement(_Link.default, (0, _assign.default)({}, linkProps, {
    className: classnames(CSS_BLOCK, className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--list"), !!inList)),
    href: url,
    ref: ref
  }), label);
});
SkipLink.displayName = 'SkipLink';
var _default = exports.default = SkipLink;